import script from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"

import "./PoolFees.vue?vue&type=style&index=0&id=016b98ee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016b98ee"]])

export default __exports__